import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ChatComponent } from './chat/chat.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { PatientDashboardComponent } from './patient-dashboard/patient-dashboard.component';
import { SupportComponent } from './support/support.component';
import { TeamChatComponent } from './team-chat/team-chat.component';
import { MyOrdersComponent } from './patient-dashboard/patientAccess/my-orders/my-orders.component';
import { MyprotocolComponent } from './patient-dashboard/patientAccess/myprotocol/myprotocol.component';
import { MybillingsComponent } from './patient-dashboard/patientAccess/mybillings/mybillings.component';
import { MyinvoicesComponent } from './patient-dashboard/patientAccess/myinvoices/myinvoices.component';

const routes: Routes = [
    {
        path: '', component: DashboardComponent, canActivate: [AuthGuard],
    },
    {
        path: 'patient-portal', component: PatientDashboardComponent, canActivate: [AuthGuard],
    },


    { path: 'calendar', component: CalendarComponent },
    { path: 'chat', component: ChatComponent },
    { path: 'teamChat', component: TeamChatComponent },
    { path: 'support', component: SupportComponent },
    { path: 'admin', loadChildren: () => import('./user/user.module').then(m => m.UserModule), canActivate: [AuthGuard], },
    { path: 'notifications', loadChildren: () => import('./about/about.module').then(m => m.AboutModule) },

    // New Links Start Here:
    { path: 'patientManagement', loadChildren: () => import('./manage-patient/manage-patient.module').then(m => m.ManagePatientModule) },
    { path: 'trash', loadChildren: () => import('./trash/trash.module').then(m => m.TrashModule) },
    { path: 'product-categories', loadChildren: () => import('./category/category.module').then(m => m.CategoryModule) },
    { path: 'product', loadChildren: () => import('./product/product.module').then(m => m.ProductModule) },
    { path: 'care-protocol', loadChildren: () => import('./careprotocol/careprotocol.module').then(m => m.CareprotocolModule) },
    { path: 'patient-protocol', loadChildren: () => import('./assigned-protocols/assigned-protocols.module').then(m => m.AssignedProtocolsModule) },
    { path: 'order', loadChildren: () => import('./order/order.module').then(m => m.OrderModule) },
    { path: 'billing', loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule) },
    { path: 'billing-profile', loadChildren: () => import('./billing-profile/billing-profile.module').then(m => m.BillingProfileModule) },
    { path: 'replenish', loadChildren: () => import('./replenish/replenish.module').then(m => m.ReplenishModule) },
    { path: 'task', loadChildren: () => import('./task/task.module').then(m => m.TaskModule) },

    // Patient ROutes
    { path: 'my-orders', component: MyOrdersComponent },
    { path: 'my-protocols', component: MyprotocolComponent },
    { path: 'My-BillingProfile', component: MybillingsComponent },
    { path: 'My-Invoices', component: MyinvoicesComponent}

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }











// temps
// { path: 'email', loadChildren: () => import('./email/email.module').then(m => m.EmailModule) },
// { path: 'pages', loadChildren: () => import('./utility/utility.module').then(m => m.UtilityModule) },
// { path: 'charts', loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule) },
// { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) },
// { path: 'admin', loadChildren: () => import('./user/user.module').then(m => m.UserModule), canActivate: [AuthGuard], },